<template>
<c-skeleton :progress="loading">
  <h1>{{ name }}</h1>
  <div v-html="post.html"/>
  <c-post-elements :elements="post.elements"/>
</c-skeleton>
</template>

<script>
import CSkeleton from '@/components/CSkeleton'
import { computed, nextTick, onUnmounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import forEach from 'dcode/functions/forEach'
import setTitle from '@/functions/setTitle'
import goScrollSmooth from 'dcode/functions/goScrollSmooth'
import CPostElements from '@/components/CPostElements'
// import { event, pageview } from 'vue-gtag'

let isID = 0

export default {
  name: 'CPost',
  components: {
    CPostElements,
    CSkeleton
  },
  setup () {
    const route = useRoute()
    const store = useStore()

    const getTable = table => {
      const header = forEach(table.querySelectorAll('th'), th => th.innerText?.trim())
      const list = []

      forEach(table.querySelectorAll('tr'), tr => {
        const value = []
        tr.querySelectorAll('td').forEach(td => value.push(td.innerText?.trim()))

        if (value.length > 0) {
          list.push(value)
        }
      })

      return {
        type: 'table',
        header,
        list,
        limit: parseInt(table.getAttribute('limit')) || undefined
      }
    }

    const postId = computed(() => route.params.code)
    const name = computed(() => store.getters.getName)
    const post = computed(() => {
      const body = document.createElement('div')
      body.innerHTML = store.getters.getPost

      return {
        elements: forEach(body.querySelectorAll('h1,h2,h3,h4,h5,h6,*[rel],img,table,iframe'), item => {
          const tag = 'getAttribute' in item ? (item.getAttribute('rel') || item.localName) : item?.nodeName
          let data

          switch (tag) {
            case '#text':
              data = {
                type: 'span',
                html: item.data.trim()
              }
              break
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
              data = {
                type: 'h',
                text: item.innerHTML
              }
              break
            case 'alert':
              data = {
                type: tag,
                color: item.getAttribute('color') || 'warning',
                icon: item.getAttribute('icon') || 'question-mark-circle',
                title: item.getAttribute('title') || undefined,
                text: item.innerHTML
              }
              break
            case 'blockquote':
              data = {
                type: tag,
                text: item.innerHTML
              }
              break
            case 'faq':
              data = {
                type: tag,
                list: forEach(item.children, li => {
                  return {
                    text: li.children[0]?.innerHTML,
                    description: li.children[1]?.innerHTML
                  }
                })
              }
              break
            case 'img':
              data = {
                type: tag,
                alt: item.getAttribute('title') || item.getAttribute('alt'),
                src: item.getAttribute('src')
              }
              break
            case 'table':
              data = getTable(item)
              break
            case 'iframe':
              data = {
                type: 'youtube',
                src: item.src
              }
              break
            default:
              data = {
                type: item.localName,
                html: item.innerHTML
              }
              break
          }

          if (data) {
            const newDiv = document.createElement('div')
            const id = `id-teleport-${isID++}`

            newDiv.setAttribute('id', id)
            item.parentElement.insertBefore(newDiv, item)
            item.parentElement.removeChild(item)

            return {
              id: `#${id}`,
              ...data
            }
          } else {
            return undefined
          }
        }),
        html: body.innerHTML
      }
    })

    let goScroll = true
    const onScroll = () => {
      if (goScroll && document.documentElement.scrollTop > 16) {
        /*
        event('scroll', {
          event_category: 'scroll',
          event_label: name.value,
          value: route.path
        })
        */

        console.log('goScroll', goScroll)
        goScroll = false
      }
    }

    window.addEventListener('scroll', onScroll)
    onUnmounted(() => window.removeEventListener('scroll', onScroll))

    watch(name, value => {
      setTitle(value)

      if (value) {
        // pageview({
        // page_title: value || route.path,
        // page_path: route.path
        // })
      }

      goScroll = true
      console.log('UP PAGE')
    })
    watch(post, async () => {
      await nextTick()
      requestAnimationFrame(() => {
        const element = document.getElementById(
          decodeURIComponent(location.hash.replace(/^#/, ''))
        )

        if (element) {
          goScrollSmooth(element, { shift: 64 })
        }
      })
    })

    setTitle(name.value)

    return {
      postId,
      loading: computed(() => store.getters.getLoading),
      name,
      post
    }
  }
}
</script>

<style lang="scss"/>
